import React from "react";
import "../../Pages/CleeQ.css";
import "../../Pages/Responsive.css";

function Footer() {
  return (
    <div className="container FooterWrapper">
      <div className="container overflow-hidden p-0">
        <div className="row gy-2">
          <div className="col-lg-4">
            <div className="FooterNav">Pages</div>
            <br />

            <div className="FooterNavLinks">
              <div>
                <a href="#Home" className="ClickLink2">
                  Home
                </a>
              </div>
              <div>
                <a href="#Membership" className="ClickLink2">
                  Membership
                </a>
              </div>
              <div>
                <a href="#Excos" className="ClickLink2">
                  Excos
                </a>
              </div>
              <div>
                <a href="#Projects" className="ClickLink2">
                  Projects
                </a>
              </div>
              <div>
                <a href="#Events" className="ClickLink2">
                  Events
                </a>
              </div>
              <div>
                <a href="#News" className="ClickLink2">
                  News
                </a>
              </div>
              <div>
                <a href="#Gallery" className="ClickLink2">
                  Photo Gallery
                </a>
              </div>
              <div>
                <a href="#AboutUs" className="ClickLink2">
                  About us
                </a>
              </div>{" "}
            </div>
          </div>
          <div className="col-lg-4">
            <div className="FooterNav">Membership</div>
            <br />

            <div className="FooterNavLinks">
              <div className="Footerx">Login</div>
              <div className="Footerx">Become a Member</div>{" "}
            </div>
          </div>

          <div className="col-lg-4">
            <div className="FooterNav">Contact us</div>
            <br />
            <div className="FooterNavLinks">
              <div className="Footerx">
                Unilag Alumni 38, Laleham Avenue, London, NW7 3HL
              </div>
              <div className="Footerx">
                Call : Dr Oluwole Adeniyan: +44 773772 6957
              </div>
              <div className="Footerx">info@unilagalumniuk.org</div>

              {/* <div className="Footerx">
                insert Twitter, FB, IG, LinkedIn & YT icons under the slogan
              </div> */}
            </div>{" "}
          </div>
        </div>
      </div>

      <div className="container FoterContainer">
        <div className="copyright-text">
          <div className="FooterNote">
            Copyright &copy;{new Date().getFullYear()} Unilag Alumni. All rights
            reserved
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
